module.exports = "/assets/data/ed542b1ed13827f1ed2903d9e4fb9d5f-BA3.data.json";